import type { ActionHandler } from '@/domains/core/applicationState/interfaces/ActionHandler';
import {
  HYDRATE,
  type HydrateAction,
} from '@/domains/core/applicationState/store/hydrateAction';
import type { EligibilityCoupon } from '@/domains/loyalty/modules/CouponEligibility/interfaces/EligibilityCoupon';
import { SpartacuxProB2BAnimationState } from '@/domains/proB2BAnimation/store/proB2BAnimation.model';
import {
  GRAPHQL_SUCCESS,
  GraphqlSuccess,
} from '@/productDiscovery/ProductPage/detail.actions';

import {
  GET_ELIGIBILITY_COUPON_FAILED,
  GET_ELIGIBILITY_COUPON_REQUEST,
  GET_ELIGIBILITY_COUPON_SUCCESS,
  type GetEligibilityCouponActions,
} from './eligibilityCoupons.actions';
import {
  initialState,
  type EligibilityCouponState,
} from './eligibilityCoupons.model';

export const actionHandlers = {
  [HYDRATE]: (state: EligibilityCouponState, action: HydrateAction) => ({
    ...state,
    ...(action.state as SpartacuxProB2BAnimationState).proB2BAnimation
      ?.eligibilityCoupon,
  }),
  [GET_ELIGIBILITY_COUPON_REQUEST]: () => ({}),
  [GET_ELIGIBILITY_COUPON_SUCCESS]: (
    state: EligibilityCouponState,
    { payload: eligibilityCoupon }: { payload: EligibilityCoupon | null },
  ) => ({
    ...state,
    eligibilityCoupon,
    error: null,
  }),
  [GET_ELIGIBILITY_COUPON_FAILED]: (
    state: EligibilityCouponState,
    { error }: { error: string },
  ) => ({
    error,
  }),
  [GRAPHQL_SUCCESS]: (state, action: GraphqlSuccess) => {
    if (!action.payload?.productCoupons?.length) return state;

    return {
      ...state,
      error: null,
      eligibilityCoupon: action.payload?.productCoupons
        .filter((coupon) => !!coupon)
        .map((coupons) => ({
          code: coupons.code,
          amount: coupons.value,
          endTime: coupons.expirationDate,
        }))
        .at(0),
    };
  },
} as ActionHandler<EligibilityCouponState, GetEligibilityCouponActions>;

export const reducer = (
  state: EligibilityCouponState = initialState,
  action: GetEligibilityCouponActions,
) => {
  if (actionHandlers[action.type]) {
    return actionHandlers[action.type](state, action);
  }
  return state;
};
